module.exports = __webpack_public_path__ + "static/img/shakespear.ffac238.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/shakespear.jpg
// module id = kIZ1
// module chunks = 1